import { NivelI } from "interfaces/Nivel";
import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { NivelRow } from "./NivelRow";

interface Props {
  elementos: NivelI[];
  renderActions?: (elemento: NivelI) => ReactNode;
}

export const NivelTable = ({ elementos = [], renderActions }: Props) => {
  const [selectedNotificacionId, setSelectedNotificacionId] = useState<
    null | number | string
  >(null);

  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleShowDetailModal = (id: number | string) => {
    setSelectedNotificacionId(id);
    setShowDetailModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            {renderActions && (
              <th className="text-center" style={{ maxWidth: "50px" }}>
                Acciones
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <NivelRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 6 : 5}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay Niveles para visualizar.</b> Para poder visualizar
                  niveles debes <br /> seleccionar el botón agregar «Nuevo
                  Nivel».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
